import { 
    Box, 
    Flex, 
    HStack, 
    Image, 
    Text, 
    Stack, 
    Menu, 
    MenuButton, 
    IconButton, 
    MenuList, 
    MenuItem,
    Avatar,
    Heading 
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";
import { IoMdExit } from "react-icons/io";
import Navigation from "./Navigation";
import useAuthentication from "@auth/hooks/useAuthentication";
import { useAppSelector } from "@app/createStore";

const Header = () => {
    const { logout } = useAuthentication();
    const { user } = useAppSelector( state => state.auth );
    return(
        <Box as="header" position="sticky" w="100%" h="3.5rem" top={0} background="white" zIndex={20} borderBottom="1px" borderColor="gray.200">
            <Box w="100%" h="100%" px={4}>
                <Flex w="100%" h="100%" alignItems="center" justifyContent="space-between">
                    <HStack w="100%" h="100%" alignItems="center" spacing={2}>
                        <Navigation/>
                        <Image display={{base:"none",md:"block"}} src="/BrandName.png" alt="The Green Company" objectFit="cover" w="200px"/>
                        <Image display={{base:"block",md:"none"}} src="/logo.png" alt="The Green Company" objectFit="cover" w="2.5rem"/>
                        <Heading fontSize="xl" as="h2" noOfLines={1}>Databridge</Heading>
                    </HStack>
                    <HStack w="20rem" h="100%" border="ActiveBorder"  justifyContent="end">
                        <Avatar name={user?.firstName + ' ' + user?.lastName} src={user?.profileImage}  borderRadius="full" w="2.8rem" h="2.8rem"/>
                        <Stack spacing={0} w="100%" display={{base:"none", md:"block"}}>
                            <Text fontSize="md" noOfLines={1}>{ user?.firstName + ' ' + user?.lastName }</Text>
                            <Text fontSize="xs" noOfLines={1} as="b">{ user?.groupName }</Text>
                        </Stack>
                        <Menu>
                            <MenuButton as={IconButton} icon={<FaChevronDown/>}/>
                            <MenuList px={2}>
                                <MenuItem as="button" borderRadius={4} icon={<IoMdExit size={22}/>} onClick={logout}>Salir</MenuItem>
                            </MenuList>
                        </Menu>
                    </HStack>
                </Flex>
            </Box>
        </Box>
    )
}

export default Header;